import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface FooterProps{
  text?: string,
  isDefault?: boolean
}

const Footer: React.FC<FooterProps> = ({text = '', isDefault = false}) => {
  const { t } = useTranslation();
const [isShow, setIsShow] = useState<boolean>(false)
useEffect(() => {
  setIsShow(isDefault)
}, [isDefault])
    
  return (
    <footer className="w-full bg-gray-100 text-center py-4 mt-auto shadow-inner">
      <p className="text-sm text-gray-600">
        &copy; {new Date().getFullYear()} {t(text)}
      </p>
      {isShow && (
        <p className="text-muted small">
        Made with ❤️ by <a href="https://mandza.eu" target="_blank" rel="noopener noreferrer">mandza.eu</a> 
      </p>
      )}
    </footer>
  );
};

export default Footer;
